import API from './api'

export const getChecklist = async () => {
  const { data } = await API.get('checklist')

  return data
}
